document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".ingredient-display__item");
  const contents = document.querySelectorAll(".mobile-display");
  const desktopContent = document.querySelector("[data-desktop-content]");

  items.forEach(item => {
    item.addEventListener("click", function () {
      items.forEach(i => i.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");

      const content = this.dataset.content;

      if (desktopContent) {
        desktopContent.innerHTML = content;
      }

      let targetContent;

      if (this.dataset.index % 2 === 0) {
        targetContent = this.nextElementSibling;
      } else {
        targetContent = this.nextElementSibling?.nextElementSibling;
      }

      if (targetContent && targetContent.classList.contains("mobile-display")) {
        targetContent.classList.add("active");
        targetContent.querySelector(".section-description").innerHTML = content;
      }
    });
  });
});